import { render, staticRenderFns } from "./editTermsAndConditions.vue?vue&type=template&id=0f90d2db&scoped=true&"
import script from "./editTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./editTermsAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f90d2db",
  null
  
)

export default component.exports